import { render, staticRenderFns } from "./primary-list.vue?vue&type=template&id=35660348&scoped=true"
import script from "./primary-list.vue?vue&type=script&lang=js"
export * from "./primary-list.vue?vue&type=script&lang=js"
import style0 from "./primary-list.vue?vue&type=style&index=0&id=35660348&prod&lang=less"
import style1 from "./primary-list.vue?vue&type=style&index=1&id=35660348&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35660348",
  null
  
)

export default component.exports